export default __webpack_public_path__ + "static/side-nav-do-6-8c7d634492fe34d7a759627b8cef550b31282f4ba7db0ac7063a8cee36f2e3c1.png";